export default function DiscountBadge({
  discount,
  quantity,
  onClick,
}: {
  discount: number;
  quantity: number;
  onClick: (quantity: number) => void;
}) {
  return (
    <span
      className="text-primary-purple bg-primary-purple/20 px-2 py-1 rounded-md text-sm cursor-pointer hover:bg-primary-purple/30 transition-all text-center"
      onClick={() => onClick(quantity)}
    >
      {discount}% off {quantity}GB+
    </span>
  );
}
